(function (window) {
  'use strict';
  if (window.StackhouseCartEdit) return;
  var active = false;
  var bindingPromise = null;
  function route(path) { return ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + path; }
  async function json(url, options) {
    var response = await fetch(url, options);
    var body = await response.json();
    if (!response.ok) throw new Error(body.message || body.description || 'Your cart could not be loaded. Please retry.');
    return body;
  }
  async function cart() { return json(route('cart.js'), {cache: 'no-store'}); }
  function post(body) { return {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(body)}; }
  async function binding() {
    if (bindingPromise) return bindingPromise;
    bindingPromise = (async function () {
      try {
        var current = await cart();
        // Shopify replaces a provisional empty-cart token on its first write.
        // An empty update establishes the cart without changing items or notes.
        if (!current.items.length) {
          await json(route('cart/update.js'), post({updates: {}}));
          current = await cart();
        }
        return String(current.token || '');
      } catch (error) { return ''; }
    })();
    try { return await bindingPromise; }
    finally { bindingPromise = null; }
  }
  function sorted(value) {
    if (!value || typeof value !== 'object') return JSON.stringify(value);
    return '{' + Object.keys(value).sort().map(function (key) { return JSON.stringify(key) + ':' + sorted(value[key]); }).join(',') + '}';
  }
  function sameLine(left, right) {
    return left && right && left.variant_id === right.variant_id &&
      left.quantity === right.quantity && sorted(left.properties) === sorted(right.properties);
  }
  function payloadLines(current, payloadId) {
    return current.items.filter(function (item) {
      return item.properties && item.properties['_Production Payload ID'] === payloadId;
    });
  }
  function cropPosition(crop, source, frame, fit, maxZoom) {
    var values = [crop.x, crop.y, crop.width, crop.height, source.w, source.h, frame[0], frame[1], fit.w, fit.h];
    if (!values.every(Number.isFinite) || values.slice(2).some(function (v) { return v <= 0; }) || crop.x < 0 || crop.y < 0 ||
        crop.x + crop.width > source.w + .01 || crop.y + crop.height > source.h + .01) throw new Error('The saved crop has invalid dimensions.');
    var sourceAspect = source.w / source.h, frameAspect = frame[0] / frame[1];
    var baseW = sourceAspect > frameAspect ? frame[1] * sourceAspect : frame[0];
    var baseH = sourceAspect > frameAspect ? frame[1] : frame[0] / sourceAspect;
    var drawW = frame[0] * source.w / crop.width, drawH = frame[1] * source.h / crop.height;
    var zoom = drawW / baseW;
    if (Math.abs(zoom - drawH / baseH) > .0001 || zoom < .9999 || zoom > maxZoom + .0001) {
      throw new Error('The saved crop cannot be restored at this size. Your cart item is preserved.');
    }
    return {zoom: Math.max(1, Math.min(maxZoom, zoom)),
      x: (-crop.x / source.w * drawW - (frame[0] - drawW) / 2) / frame[0] * fit.w,
      y: (-crop.y / source.h * drawH - (frame[1] - drawH) / 2) / frame[1] * fit.h};
  }
  function cropRestoration(recipe, source) {
    var client = recipe.crop_audit && recipe.crop_audit.client;
    var applied = client && client.applied;
    var result = {crop: Object.assign({}, recipe.crop), recoveredApplied: false, requiresApply: false, auditState: null};
    if (!client || !Object.keys(client).length) return result;
    result.auditState = {current: client, applied: applied, sequence: client.crop_sequence, previous: client.crop_previous_revision};
    function sameNumber(left, right) {
      return typeof left === 'number' && Number.isFinite(left) && typeof right === 'number' && Number.isFinite(right) && Math.abs(left - right) <= .001;
    }
    function sameCrop(value, crop) {
      return ['x', 'y', 'width', 'height'].every(function (key) { return sameNumber(value['crop_' + key], crop[key]); });
    }
    function valid(value) {
      return value && typeof value.crop_revision === 'string' && /^[A-Za-z0-9][A-Za-z0-9_:-]{0,95}$/.test(value.crop_revision) &&
        value.crop_space === 'oriented' && typeof value.crop_source_id === 'string' && !!value.crop_source_id &&
        recipe.image.id !== undefined && String(value.crop_source_id) === String(recipe.image.id) &&
        sameNumber(value.crop_source_width, source.w) && sameNumber(value.crop_source_height, source.h) &&
        [0, 90].indexOf(value.crop_rotation) !== -1 &&
        ['x', 'y', 'width', 'height'].every(function (key) { return typeof value['crop_' + key] === 'number' && Number.isFinite(value['crop_' + key]); }) &&
        value.crop_x >= 0 && value.crop_y >= 0 && value.crop_width > 0 && value.crop_height > 0 &&
        value.crop_x + value.crop_width <= source.w + .001 && value.crop_y + value.crop_height <= source.h + .001;
    }
    if (!applied && !client.crop_has_applied && recipe.crop_audit.applied_matches_server !== false) return result;
    if (!valid(client) || !valid(applied) || !sameCrop(client, recipe.crop) ||
        client.crop_applied_revision !== applied.crop_revision ||
        client.crop_rotation !== applied.crop_rotation ||
        !sameNumber(client.crop_width, applied.crop_width) || !sameNumber(client.crop_height, applied.crop_height) ||
        recipe.crop_audit.client_matches_server === false) {
      result.requiresApply = true;
      return result;
    }
    result.rotation = applied.crop_rotation;
    if (!sameCrop(applied, recipe.crop)) {
      result.crop = {x: applied.crop_x, y: applied.crop_y, width: applied.crop_width, height: applied.crop_height};
      result.recoveredApplied = true;
      result.auditState = {current: applied, applied: applied, sequence: client.crop_sequence, previous: client.crop_revision};
    }
    return result;
  }
  async function read(key, base) {
    var current = await cart();
    var line = current.items.find(function (item) { return item.key === key; });
    if (!line || !line.properties || !line.properties['_Cart Edit Token']) {
      throw new Error('This item is unavailable for editing in this cart. Your cart has not been changed.');
    }
    var response = await json(base.replace(/\/$/, '') + '/create-orders/ajax/cart-recipe/', post({
      payload_id: line.properties['_Production Payload ID'], edit_token: line.properties['_Cart Edit Token'], cart_token: current.token
    }));
    if (!response.ok || !response.recipe || response.recipe.payload_id !== line.properties['_Production Payload ID']) {
      throw new Error(response.message || 'The saved configuration could not be verified.');
    }
    return {line: line, recipe: response.recipe, cartToken: current.token};
  }
  async function replace(options) {
    if (active) throw new Error('Your cart update is already in progress.');
    active = true;
    var before = options.original, originalId = before.properties && before.properties['_Production Payload ID'];
    var replacementId = '', attempted = false, properties;
    function exactReplacement(item) {
      return item && Number(item.variant_id) === Number(options.variantId) && item.quantity === options.quantity && sorted(item.properties) === sorted(properties);
    }
    function uncertain() {
      return Object.assign(new Error('The update could not be confirmed. Review your cart before trying again; both versions may still be present.'), {cartEditUncertain: true});
    }
    try {
      var current = await cart();
      var originals = originalId ? payloadLines(current, originalId) : [];
      if (current.token !== options.cartToken || originals.length !== 1 || !sameLine(before, originals[0])) {
        throw new Error('This cart item changed while you were editing. Open it from the cart again to review its latest settings.');
      }
      var integrity = window.StackhouseCartLineIntegrity;
      properties = integrity.withFunnelSession
        ? integrity.withFunnelSession(options.propertyEntries)
        : integrity.normalizeProperties(options.propertyEntries);
      replacementId = properties['_Production Payload ID'];
      if (!replacementId || replacementId === before.properties['_Production Payload ID']) throw new Error('The replacement needs its own saved configuration.');
      if (payloadLines(current, replacementId).length) throw new Error('This replacement is already in your cart. Review your cart before trying again.');
      if (before.properties['_Rush Production']) properties['_Rush Production'] = before.properties['_Rush Production'];
      attempted = true;
      await integrity.addConfiguredItem({
        variantId: options.variantId,
        quantity: options.quantity,
        properties: properties,
        retryGeneratedVariantPropagation: Boolean(options.retryGeneratedVariantPropagation)
      });
      current = await cart();
      originals = payloadLines(current, originalId);
      var replacements = payloadLines(current, replacementId);
      var original = originals[0], replacement = replacements[0];
      if (current.token !== options.cartToken || originals.length !== 1 || replacements.length !== 1 || !sameLine(before, original) || !exactReplacement(replacement)) {
        throw new Error('The cart changed before the replacement was confirmed.');
      }
      try { await json(route('cart/change.js'), post({id: original.key, quantity: 0})); }
      catch (error) { /* Read back an uncertain response before deciding its outcome. */ }
      current = await cart();
      originals = payloadLines(current, originalId);
      replacements = payloadLines(current, replacementId);
      if (current.token !== options.cartToken || originals.length || replacements.length !== 1 || !exactReplacement(replacements[0])) throw new Error('The replacement could not be completed.');
      return current;
    } catch (error) {
      if (attempted) {
        try {
          var observed = await cart();
          if (observed.token !== options.cartToken) throw new Error('The cart identity changed.');
          originals = payloadLines(observed, originalId);
          replacements = payloadLines(observed, replacementId);
          var old = originals[0], extra = replacements[0];
          if (!originals.length && replacements.length === 1 && exactReplacement(extra)) return observed;
          if (originals.length === 1 && replacements.length <= 1 && sameLine(before, old) && (!extra || exactReplacement(extra))) {
            if (extra) {
              try { await json(route('cart/change.js'), post({id: extra.key, quantity: 0})); }
              catch (error) { /* The removal response may be lost; verify below. */ }
            }
            var recovered = await cart();
            originals = payloadLines(recovered, originalId);
            if (recovered.token !== options.cartToken || originals.length !== 1 || !sameLine(before, originals[0]) ||
                payloadLines(recovered, replacementId).length) {
              throw new Error('Cart recovery could not be verified.');
            }
            throw Object.assign(new Error('The update failed. Your original cart item is preserved. Please retry.'), {cartRecovered: true});
          }
          throw new Error('Cart state could not be confirmed.');
        } catch (recoveryError) {
          if (recoveryError.cartRecovered) throw recoveryError;
          throw uncertain();
        }
      }
      throw error;
    } finally { active = false; }
  }
  window.StackhouseCartEdit = {read: read, replace: replace, cart: cart, sameLine: sameLine, cropPosition: cropPosition, cropRestoration: cropRestoration,
    binding: binding};
  document.addEventListener('click', async function (event) {
    var button = event.target.closest('[data-stackhouse-edit-line]');
    if (!button || button.disabled) return;
    event.preventDefault();
    button.disabled = true;
    var label = button.textContent;
    button.textContent = 'Opening saved print…';
    var config = window.StackhouseCartLineIntegrityConfig || {};
    var endpoint = String(config.repairEndpoint || '');
    try {
      if (!endpoint.includes('/create-orders/')) throw new Error('The print editor is temporarily unavailable.');
      var saved = await read(button.dataset.stackhouseEditLine, endpoint.split('/create-orders/')[0]);
      window.location.href = route('pages/start-order') + '?product=' + encodeURIComponent(saved.recipe.family) + '&cart_edit=' + encodeURIComponent(saved.line.key);
    } catch (error) {
      button.disabled = false; button.textContent = label;
      var message = button.parentNode.querySelector('[data-cart-edit-error]');
      if (!message) { message = document.createElement('p'); message.dataset.cartEditError = ''; message.setAttribute('role', 'alert'); button.after(message); }
      message.textContent = error.message;
    }
  });
})(window);
